import { render } from "./TrialBalanceTable.vue?vue&type=template&id=61a4547f&scoped=true"
import script from "./TrialBalanceTable.vue?vue&type=script&lang=js"
export * from "./TrialBalanceTable.vue?vue&type=script&lang=js"

import "./TrialBalanceTable.vue?vue&type=style&index=0&id=61a4547f&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61a4547f"]])

export default __exports__